import { render, staticRenderFns } from "./product-introduction-cardv2.vue?vue&type=template&id=661a95b3&scoped=true&"
import script from "./product-introduction-cardv2.vue?vue&type=script&lang=js&"
export * from "./product-introduction-cardv2.vue?vue&type=script&lang=js&"
import style0 from "./product-introduction-cardv2.vue?vue&type=style&index=0&id=661a95b3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661a95b3",
  null
  
)

export default component.exports